import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {InfiniteScrollDirective} from 'ngx-infinite-scroll';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {TranslateModule} from '@ngx-translate/core';
import {NgSelectModule} from '@ng-select/ng-select';
import {LoggerModule, NgxLoggerLevel} from 'ngx-logger';
import {GoogleMapsModule} from '@angular/google-maps';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {NgxCurrencyDirective} from 'ngx-currency';
import {provideNativeDateAdapter} from "@angular/material/core";

@NgModule({
  imports: [
    GoogleMapsModule,
    NgxCurrencyDirective,
    InfiniteScrollDirective,
    LoggerModule.forRoot({
      level: NgxLoggerLevel.TRACE,
      disableConsoleLogging: false
    })
  ],
  providers: [NgbActiveModal, provideNativeDateAdapter()],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    NgbModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    TranslateModule,
    NgSelectModule,
    GoogleMapsModule,
    MatDatepickerModule,
//    ChartsModule,
    NgxCurrencyDirective,
  ]
})
export class SharedLibsModule {
}
